import React from "react";
import styles from "./index.module.css";

const Search = ({ onClick, className }) => {
  return (
    <div onClick={onClick} className={className}>
      <svg
        version="1.1"
        id="icon-search"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        className={styles.search}
        viewBox="0 0 512 512"
      >
        <g id="XMLID_1_">
          <path
            id="XMLID_5_"
            fill="currentColor"
            d="M505.6,475.6L363.8,332c28-35.4,44.8-79.3,44.8-127.8C408.6,91.4,317.2,0,204.4,0S0.1,91.4,0.1,204.2
          s91.4,204.2,204.2,204.2c48.5,0,93.3-16.8,128.7-45.7l141.8,142.7c4.7,4.7,10.3,6.5,15.9,6.5s11.2-1.9,14.9-5.6
          C514,498.9,514,485,505.6,475.6z M203.4,364.6c-42.9,0-83-16.8-113.8-46.6S43,247.1,43,204.2s16.8-83,46.6-113.8
          c30.8-30.8,70.9-46.6,113.8-46.6s83,16.8,113.8,46.6s46.6,70.9,46.6,113.8s-16.8,83-46.6,113.8
          C287.4,347.9,246.3,364.6,203.4,364.6z"
          />
        </g>
      </svg>
    </div>
  );
};

const CloseIcon = ({ onClick, className }) => {
  return (
    <div onClick={onClick} className={className}>
      <svg
        version="1.1"
        id="icon-close"
        xmlns="http://www.w3.org/2000/svg"
        x="0px"
        y="0px"
        viewBox="0 0 50 50"
        enableBackground="new 0 0 50 50"
        className={styles.close}
      >
        <path
          fill="currentColor"
          d="M9.016,40.837c0.195,0.195,0.451,0.292,0.707,0.292c0.256,0,0.512-0.098,0.708-0.293l14.292-14.309
        l14.292,14.309c0.195,0.196,0.451,0.293,0.708,0.293c0.256,0,0.512-0.098,0.707-0.292c0.391-0.39,0.391-1.023,0.001-1.414
        L26.153,25.129L40.43,10.836c0.39-0.391,0.39-1.024-0.001-1.414c-0.392-0.391-1.024-0.391-1.414,0.001L24.722,23.732L10.43,9.423
        c-0.391-0.391-1.024-0.391-1.414-0.001c-0.391,0.39-0.391,1.023-0.001,1.414l14.276,14.293L9.015,39.423
        C8.625,39.813,8.625,40.447,9.016,40.837z"
        />
      </svg>
    </div>
  );
};

export { CloseIcon, Search };
